<div class="dialog">
    <div class="dialog-header">
        <h3>{{ 'COMPLAINT|Przekazywanie historii zgłoszenia {complaintNumber}' | translate: {complaintNumber: data.complaintNumber} }}</h3>
        <button
            iccIconButton
            (click)="close()"
            appearance="flat"
        >
            <icc-icon name="close"></icc-icon>
        </button>
    </div>
    <div class="dialog-body">
        <p>{{ 'COMPLAINT|Podaj adres e-mail na jaki zostanie przesłana historia reklamacji' | translate }}</p>
        <div class="flex-horizontal w-100">
            <icc-form-field
                size="small"
            >
                <icc-input
                    type="email"
                    name="email"
                    [(ngModel)]="email"
                ></icc-input>
            </icc-form-field>
        </div>
    </div>
    <div class="dialog-footer">
        <div class="flex-horizontal w-100">
            <button iccButton appearance="flat" (click)="close()">{{ 'INTERFACE|Anuluj' | translate}}</button>
            <div class="flex-horizontal right">
                <button iccButton (click)="sendEmail()">{{ 'INTERFACE|Wyślij' | translate}}</button>
            </div>
        </div>
    </div>
</div>
<div
    class="curtain"
    (click)="close()"
></div>